(() => {
 if (customElements.get('ln-scroll-reveal')) return;
 class LNScrollReveal extends HTMLElement {
  connectedCallback() {
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');this.abort = new AbortController();this.nodes = new Set();this.timers = new Set();
   document.addEventListener('focusin',event => {const node = event.target.closest?.('.ln-scroll-pending');if(node)this.reveal(node);},{capture:true,signal:this.abort.signal});
   this.motion.addEventListener('change',() => this.configure(),{signal:this.abort.signal});
   document.addEventListener('shopify:section:load',() => this.configure(),{signal:this.abort.signal});
   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => this.configure(),{once:true,signal:this.abort.signal}); else this.configure();
  }
  configure() {
   this.clear();
   if (this.motion.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
   const main = document.querySelector('#MainContent');if (!main) return;
   this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    this.reveal(entry.target);
   }),{threshold:0,rootMargin:'0px 0px -12% 0px'});
   const productPage = main.dataset.template?.startsWith('product');
   const sections = [...main.querySelectorAll(':scope > .shopify-section')];
   const targets = [];
   sections.forEach((section,i) => {
    if (!i || section.querySelector('[data-pdx]')) return;
    const inner = section.querySelector('.lnmc-row') ? [...section.querySelectorAll('.lnmc-header,.lnmc-row')] : [section];
    targets.push(...inner);
   });
   if (productPage) targets.push(...main.querySelectorAll('.lnps,.cxp-policies'));
   targets.forEach(node => {
    const box = node.getBoundingClientRect();
    if (!box.height || box.top < innerHeight * .92) return;
    node.style.setProperty('--ln-reveal-duration',this.dataset.duration+'ms');node.style.setProperty('--ln-reveal-distance',this.dataset.distance+'px');
    node.classList.add('ln-scroll-pending');this.nodes.add(node);this.observer.observe(node);
   });
  }
  reveal(node) {
   this.observer?.unobserve(node);node.classList.remove('ln-scroll-pending');node.classList.add('ln-scroll-enter');
   const timer = setTimeout(() => {node.classList.remove('ln-scroll-enter');this.timers.delete(timer);}, Number(this.dataset.duration) + 100);this.timers.add(timer);
  }
  clear() {this.observer?.disconnect();this.timers?.forEach(clearTimeout);this.timers?.clear();this.nodes?.forEach(n=>{n.classList.remove('ln-scroll-pending','ln-scroll-enter');n.style.removeProperty('--ln-reveal-duration');n.style.removeProperty('--ln-reveal-distance');});this.nodes?.clear();}
  disconnectedCallback(){this.clear();this.abort?.abort();}
 }
 customElements.define('ln-scroll-reveal',LNScrollReveal);
})();
